import { useMutation } from 'react-query';
import message from 'antd/es/message';
import { openNewWindow, request, toastError } from '@/utils';

import { GroupProposal, GroupProposalType } from '../types';

export const useGroupProposalCreate = (id: number | string, onSuccess?: () => void) => {
  return useMutation(
    ({ type, data }: { type: GroupProposalType; data: any }) => {
      return request.post<{ is_success: boolean; proposal: GroupProposal }>(
        '/group_proposal/create',
        { group_id: id, type, data },
      );
    },
    {
      onSuccess(res) {
        if (!res?.proposal) {
          toastError('Create failed');
          return;
        }

        message.success('Created');
        openNewWindow(`/group-proposal/${res.proposal.id}`, '_blank');
        onSuccess && onSuccess();
      },
      onError(err: any) {
        toastError(err || 'Failed');
      },
    },
  );
};
